import { createSlice } from '@reduxjs/toolkit';

const courseSlice = createSlice({
  name: 'course',
  initialState: {
    count:0,
    limit:0,
    records:[]
  },
  reducers: {
    addCourse: (state, action) => {
      return action.payload
    }
  },
});

export const { addCourse } = courseSlice.actions;
export default courseSlice.reducer;
